import React, { useState, useRef, useEffect } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./ResultSortBy.css";

export const ResultSortBy = ({ sortby, selectedSort, onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (field) => {
    onChange(field);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = (() => {
    const found = sortby.find((obj) => {
      const key = Object.keys(obj)[0];
      return obj[key].field === selectedSort;
    });

    if (!found) return "Select";

    const key = Object.keys(found)[0];
    return found[key].display_name;
  })();

  return (
    <div className={`custom-dropdown ${open ? "open" : ""}`} ref={dropdownRef}>
      <label htmlFor="">Sort By</label>
      <button type="button" className="dropdown-toggle" onClick={() => setOpen(!open)}>
        {selectedLabel} <ArrowDropDownIcon fontSize="small" />
      </button>

      {open && (
        <ul className="dropdown-menu">
          {sortby.map((item) => {
            const key = Object.keys(item)[0];
            const { display_name, field } = item[key];
            return (
              <li
                key={field}
                className={`dropdown-item ${field === selectedSort ? "selected" : ""}`}
                onClick={() => handleSelect(field)}
              >
                {display_name}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
